/*
 * Design-Version BF26 - kleine Laufzeit-Helfer. Wird nur geladen, wenn Theme-Einstellungen > Design-Version = BF26
 * (layout/theme.liquid).
 *
 * Die Hervorhebung "Du sparst <Betrag>" steht in assets/ll-savings-highlight.js (laedt in beiden Designs, weil der
 * Desktop-Sticky auch im Classic-Design die BF26-Preisliste nutzt).
 */

/*
 * Versandhinweis neben dem Preis (Bikes, snippets/price-list.liquid) - die einzige Versandangabe im BF26-Design:
 * gratis -> "Gratis Versand" (gruen, Klasse is-free), sonst "zzgl. 19,90€ Versand", jeweils mit LKW-Icon. Das Theme
 * (VariantBikeShippingInformation) schreibt den Hinweis beim Variantenwechsel komplett neu - danach werden Text,
 * Klasse und Icon hier wieder gesetzt.
 */
const updateShippingNote = (element) => {
  const text = element.getAttribute("data-ll-free-text");
  const free = element.querySelector(".freeship");
  const target = element.querySelector(".freeship .link");
  // Erstes Wort ("Gratis") einzeln ausgezeichnet - nur das wird gruen (assets/ll-design-bf26.css)
  if (text && target && (target.textContent.trim() !== text || !target.querySelector(".ll-ship-free-word"))) {
    const [first, ...rest] = text.split(" ");
    const word = document.createElement("span");
    word.className = "ll-ship-free-word";
    word.textContent = first;
    target.replaceChildren(word, document.createTextNode(rest.length ? ` ${rest.join(" ")}` : ""));
  }
  element.classList.toggle("is-free", Boolean(free));

  // LKW-Icon vorne einsetzen (Vorlage aus snippets/price-list.liquid), falls das Theme es beim Neuschreiben entfernt hat
  if (!element.querySelector(".ll-ship-icon")) {
    const template = element.parentElement?.querySelector("template[data-ll-ship-icon]") || document.querySelector("template[data-ll-ship-icon]");
    if (template) {
      const icon = document.createElement("span");
      icon.className = "ll-ship-icon";
      icon.setAttribute("aria-hidden", "true");
      icon.append(template.content.cloneNode(true));
      element.prepend(icon);
    }
  }
};

document.querySelectorAll("variant-bike-shipping-information[data-ll-free-text]").forEach((element) => {
  updateShippingNote(element);
  new MutationObserver(() => updateShippingNote(element)).observe(element, { childList: true, subtree: true, characterData: true });
});

/*
 * Akkordeons der Produktseite (snippets/ll-accordion.liquid): Spruenge zu Inhalten in einem zugeklappten Akkordeon
 * oeffnen es zuerst - Anker-Links (#id) und die Highlight-Icons oben (data-target, scrollToHighlight in
 * snippets/ll-highlights-short.liquid). Laeuft in der Capture-Phase, also vor dem eigentlichen Scrollen.
 */
const openAccordionFor = (target) => {
  const details = target?.closest("details.ll-accordion");
  if (details && !details.open) {
    details.open = true;
  }
};

document.addEventListener("click", (event) => {
  const trigger = event.target.closest("[data-target], a[href^='#']");
  if (!trigger) {
    return;
  }
  const id = trigger.getAttribute("data-target") || trigger.getAttribute("href").slice(1);
  if (id) {
    openAccordionFor(document.getElementById(id));
  }
}, true);

const openFromHash = () => {
  if (location.hash.length > 1) {
    const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    openAccordionFor(target);
    target?.scrollIntoView({ block: "start" });
  }
};
window.addEventListener("hashchange", openFromHash);
openFromHash();

/*
 * Akkordeon-Gruppe zusammenhalten: Liegen andere Sections dazwischen (z. B. Kundenbewertungen zwischen Highlights und
 * Produktsicherheit), werden die Akkordeon-Sections direkt hinter die erste gestellt. Betrifft nur Inhalte weit unter
 * dem sichtbaren Bereich - kein Layout-Shift beim Laden. Die Reihenfolge innerhalb der Gruppe bleibt wie im Template.
 */
const accordionSections = [...document.querySelectorAll(".shopify-section")]
  .filter((section) => section.querySelector(":scope > .ll-accordion"));
accordionSections.slice(1).forEach((section, index) => {
  const previous = accordionSections[index];
  if (previous.nextElementSibling !== section) {
    previous.after(section);
  }
});


/*
 * Reihenfolge unter dem Produkt (nur Produktseiten mit BF26-Akkordeons):
 *   1. Beschreibung (offen) an die Stelle des Kategorie-Sliders
 *   2. Akkordeons (Spezifikationen, Geometrie, Highlights, Produktsicherheit)
 *   3. Kundenbewertungen
 *   4. Slider "> X weitere Artikel dieser Kategorie"
 * Achtung: Die Deals-Section (artikel-dieser-collection) traegt dieselbe Klasse wie der Kategorie-Slider - deshalb
 * ausdruecklich ausgeschlossen. Alles liegt unter dem sichtbaren Bereich - kein Layout-Shift beim Laden.
 */
const categorySlider = document.querySelector(".shopify-section.shopify-section-artikel-dieser-kategorie:not(.shopify-section-artikel-dieser-collection)");
const descriptionSection = document.querySelector(".shopify-section.shopify-section--product-description");
const lastAccordionSection = accordionSections[accordionSections.length - 1];
if (categorySlider && descriptionSection && lastAccordionSection) {
  categorySlider.before(descriptionSection);
}
if (categorySlider && lastAccordionSection) {
  const reviews = lastAccordionSection.nextElementSibling?.classList.contains("shopify-section--apps")
    ? lastAccordionSection.nextElementSibling
    : null;
  (reviews || lastAccordionSection).after(categorySlider);
}

/*
 * Abstand zur Beschreibung: die sichtbare Section direkt davor markieren (leere Section-Huellen ueberspringen),
 * assets/ll-design-bf26.css nimmt ihr den unteren Section-Abstand. Laeuft nach dem Umsortieren oben.
 */
const descriptionForSpacing = document.querySelector(".shopify-section.shopify-section--product-description");
if (descriptionForSpacing && document.querySelector("details.ll-accordion")) {
  let previous = descriptionForSpacing.previousElementSibling;
  while (previous && previous.offsetHeight === 0) {
    previous = previous.previousElementSibling;
  }
  previous?.classList.add("ll-before-description");
}
